import { FC, useMemo } from "react";
import { ColumnDef, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import GenericTable from "./GenericTable";
import type { IAsset } from "@api/IWalletController";
import DynamicRelativeTime from "./cells/DynamicTimer";
import TokenAsset from "./cells/TokenCell";
import ContractAddress from "./cells/ContractCell";
import AmountDisplay from "./cells/AmountCell";
import DeployCountDisplay from "./cells/DeployCountCell";
import ActionButton from "./cells/ActionButton";
import { NewToken } from "../types/index.types";
interface DeployTableProps {
    history: NewToken[];
}

const DeployTable: FC<DeployTableProps> = ({ history }) => {
    const columns = useMemo<ColumnDef<NewToken>[]>(
        () => [
            {
                accessorKey: "asset1",
                header: "Pair",
                cell: ({ getValue }) => {
                    const asset = getValue<IAsset | string | null>();
                    return <TokenAsset asset={asset} />;
                },
            },
            {
                accessorKey: "tokenOrPoolAddress",
                header: "Contract",
                cell: ({ getValue }) => {
                    const contract = getValue<string>();
                    return <ContractAddress contract={contract} />;
                },
            },
            {
                accessorKey: "deployAmount",
                header: "Deploy Amount",
                cell: ({ getValue }) => {
                    const value = getValue<number>();
                    return <AmountDisplay value={value} />;
                },
            },
            {
                accessorKey: "devDeployHistoryTonBalance",
                header: "Dev TON Balance",
                cell: ({ getValue }) => {
                    const value = getValue<number>();
                    return <AmountDisplay value={value} />;
                },
            },
            {
                accessorKey: "devDeployHistoryJettonBalance",
                header: "Dev Jetton Balance",
                cell: ({ getValue }) => {
                    const value = getValue<number>();
                    return <AmountDisplay value={value} />;
                },
            },
            {
                accessorKey: "devDeployCount",
                header: "Total Deploy",
                cell: ({ getValue }) => {
                    const count = getValue<number>();
                    return <DeployCountDisplay count={count} />;
                },
            },
            {
                accessorKey: "devWallet",
                header: "Dev Wallet",
                cell: ({ getValue }) => {
                    const contract = getValue<string>();
                    return <ContractAddress contract={contract} />;
                },
            },
            {
                accessorKey: "createdAt",
                header: "Time Deploy",
                cell: ({ row }) => {
                    const timeString = row.original.createdAt;
                    return <DynamicRelativeTime dateString={timeString} />;
                },
            },
            {
                header: "Action",
                cell: () => <ActionButton />,
            },
        ],
        [],
    );

    const table = useReactTable({
        data: history,
        columns,
        getCoreRowModel: getCoreRowModel(),
    });

    return <GenericTable table={table} title="Deploy Mempad Checker" />;
};

export default DeployTable;
